/**
 * ร้านค้า NPC — กฎที่ทั้งสองฝั่งต้องเห็นตรงกัน
 *
 * **อยู่ใน shared เพราะ client ต้องวาดรายการและราคาให้ตรงกับที่ server ยอมรับ**
 * เคยเขียนกฎไว้สองที่ (client กรองเฉพาะของกิน ส่วน server ขายของสวมใส่ด้วย)
 * ผลคือของที่ร้านขายได้จริงไม่มีปุ่มให้กดเลย — ซื้อได้แต่ไม่มีทางกด
 * ย้ายมาที่เดียวแล้วอาการนั้นเกิดอีกไม่ได้
 *
 * ส่วนการตัดสินว่าคำสั่งซื้อขายผ่านไหม (ระยะ เงิน ของในกระเป๋า)
 * ยังอยู่ฝั่ง server เท่านั้นตามกฎข้อ 1 — ดู `server/src/shop.ts`
 *
 * กฎราคา
 *   - ของกิน (`heal`) ซื้อได้ที่ราคา `price` ใน items.json
 *   - ซื้อแล้วขายคืนได้ครึ่งราคา กันซื้อ-ขายวนเป็นเงินฟรี
 *   - วัตถุดิบ (`material`) ซื้อไม่ได้ ขายได้เต็มราคา `price` เพราะราคานั้นคือค่าของมันเอง
 *   - การ์ด (`card`) ขายไม่ได้ ของหายาก 0.02% ถ้าขายคืนได้จะกดมูลค่าทั้งระบบ (รอเฟส 3)
 *   - ของสวมใส่ (`equip`) ร้านขายชุดเริ่มต้น และรับซื้อคืนครึ่งราคาเหมือนของกิน
 */
import { isRefineItem } from "./refine.js";
/** ซื้อแล้วขายคืนได้กี่ส่วนของราคาซื้อ */
export const BUYBACK_RATE = 0.5;
/** ระยะจากใจกลางเมืองที่ยังคุยกับร้านได้ (หน่วยโลก) */
export const SHOP_RANGE = 12;
/**
 * ร้านในเมืองขายของสวมใส่ที่ต้องใช้ Base Level ไม่เกินนี้
 *
 * ของแรงกว่านี้ต้องไปตีมอนเอา ไม่ใช่ซื้อเอาทั้งหมด
 * (ยังไม่ขัดกฎข้อ 2 เพราะจ่ายด้วยโกลด์ที่ได้จากการเล่น ไม่ใช่เงินจริง)
 */
export const SHOP_EQUIP_LEVEL = 1;
/** รายการที่ร้านขาย อ่านจาก items.json ไม่ได้ฝังในโค้ด เรียงจากถูกไปแพง */
export function shopStock(items, zone) {
    // ร้านอาวุธประจำเมือง (ZoneDef.shop): อาวุธ/มือรองสายที่เมืองนี้ขาย ถึงเลเวลที่กำหนด
    const special = (i) => !!zone?.shop && i.kind === "equip"
        && (i.slot === "weapon" || i.slot === "offhand") && !!i.weaponType
        && zone.shop.weapons.includes(i.weaponType) && (i.reqLevel ?? 1) <= zone.shop.maxLevel
        && i.rarity !== "legend";
    // บริการเฉพาะเมือง (shared/towns.ts): ของช่องอื่นที่เมืองนี้ขาย (ไม่ขาย legend — ของแบบนั้นต้องล่าเอง)
    const extra = (i) => !!zone?.shop?.gear && i.kind === "equip" && !!i.slot
        && zone.shop.gear.slots.includes(i.slot) && (i.reqLevel ?? 1) <= zone.shop.gear.maxLevel
        && i.rarity !== "legend";
    return Object.values(items)
        .filter((i) => i.kind === "heal"
        || i.kind === "teleport"
        || (i.kind === "equip" && (i.reqLevel ?? 1) <= SHOP_EQUIP_LEVEL)
        || isRefineItem(i.id)
        || special(i)
        || extra(i))
        .sort((a, b) => a.price - b.price);
}
/** ร้านรับซื้อชิ้นนี้ไหม และรับที่ราคาเท่าไรต่อชิ้น 0 = ไม่รับซื้อ */
export function sellPrice(item) {
    if (!item)
        return 0;
    if (isRefineItem(item.id)) {
        return Math.floor(item.price * BUYBACK_RATE);
    }
    if (item.kind === "material")
        return item.price;
    if (item.kind === "heal" || item.kind === "teleport" || item.kind === "equip") {
        return Math.floor(item.price * BUYBACK_RATE);
    }
    return 0;
}
//# sourceMappingURL=shop.js.map